import {Component, Input, Output, EventEmitter, OnInit} from '@angular/core';
import { Agent } from '../../../classes/agent';
import { PreferencesService } from '../../../services/preferences.service';
import { CredentialsService } from '../../../services/credentials.service';
import { HasSubscriptions } from '../../has-subscriptions';

@Component({
  selector: 'app-toggle-favourite-agent',
  templateUrl: './toggle-favourite-agent.component.html',
  styleUrls: ['./toggle-favourite-agent.component.scss', './toggle-favourite-agent.mobile.component.scss']
})
export class ToggleFavouriteAgentComponent extends HasSubscriptions implements OnInit {

  constructor(
    private preferenceService: PreferencesService,
    private credentialsService: CredentialsService) {
      super();
  }

  ngOnInit() {
    this.addSub(this.credentialsService.isLoggedIn.subscribe((val) => this.isLoggedIn = val));

  }

  // This may be the same as the agent ID, but will be different when favouriting a different agent
  @Input() favouriteAgentId: string;
  @Input() agent: Agent;

  // FIXME: fix this for accessibility
  @Output() onFocus: EventEmitter<Event> = new EventEmitter<Event>();

  showPopup: boolean = false;
  showConfirmation: boolean = false;

  isLoggedIn: boolean = false;

  /**
   * We don't allow toggling favourites if they're anonymous
   * @param isFavourited - the new status
   * @param confirmFavourite - when they're overwriting an existing one, we need a confirmation that they want to update
   */
  toggleFavouriteAgent(isFavourited: boolean, confirmFavourite?: boolean) {
    this.showPopup = true;
    if (!this.isLoggedIn) return;

    if (this.favouriteAgentId && this.favouriteAgentId !== this.agent.sourceSystemId && !confirmFavourite) {
      this.showConfirmation = true;
    }
    else {
      this.preferenceService.toggleFavouriteAgent(isFavourited ? this.agent.sourceSystemId : null, isFavourited ? this.agent.detailUrl : null);
    }
  }

  onClick($event) {
    $event.preventDefault();
    this.showPopup = false;
  }
}
